/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { toast } from 'react-toastify';

const bannedTexts = ["Authorization Header Invalid: jwt malformed"]

export default class MessageCenter{

    constructor(){}

    
    undoAction(undo, msg) {
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', paddingLeft: '2px'}}>
                <span style={{fontWeight: 'bold'}}>{msg ? msg : 'File moved successfully!'}</span>
                <span style={{textDecoration: 'underline'}} onClick={() => undo()}>undo</span>
            </div>
        );
    }

    success(msg){
     return toast.success(`${msg}`, {
            position: "top-right",
            autoClose: 7000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
    }

    error(msg,hash = false){
        if(msg in bannedTexts ) return;
        let e = msg == "User is not authenticated, please Login" ? {toastId:'not-logged-in'} : hash ? {toastId:msg.replace(/([0-z]{8})([0-z]{4})([0-z]{4})([0-z]{4})([0-z]{12})/,"$1-$2-$3-$4-$5")} : {}
        return toast.error(`${msg}`, {...{
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            }, ...e});
    }

    successWithAction(undo, msg) {
        return toast.success(this.undoAction(undo, msg), {
            position: "top-right",
            autoClose: 7000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
       
    }



}